import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { FileTypesEnum } from '@shared/enums';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
@Pipe({
    name: 'basePath',
    standalone: false
})
export class BasePathPipe implements PipeTransform {

  public transform(filename: string, type: FileTypesEnum): string {
    const baseUrl = environment.baseUrlImage;

    const pdfPath = '/files/published/';
    const pdfImagePath = '/img/published/cover/x1/';
    const newsImagePath = '/img/news/';

    const defaultPdfPath = 'assets/no-pdf.pdf';
    const defaulImagePath = 'assets/no-image.png';

    switch(type) {
      case FileTypesEnum.PDF:
        return filename ? `${baseUrl}${pdfPath}${filename}` : defaultPdfPath;
      case FileTypesEnum.PDF_IMAGE:
        return filename ? `${baseUrl}${pdfImagePath}${filename}` : defaulImagePath;
      case FileTypesEnum.NEWS_IMAGE:
        return filename ? `${baseUrl}${newsImagePath}${filename}` : defaulImagePath;
      default:
        return defaulImagePath;
    }
  }
}
